/**
 * Contato do suporte do GeoGuard mostrado na tela de falha de carga — GUPM-336.
 *
 * O e-mail NÃO fica no código: mora em `contacts` (sem a marcação de emergência,
 * JF Brasil), numa linha de UUID fixo — mesmo padrão dos outros contatos de suporte
 * (GUPM-200). O seed versiona só a linha com placeholder; o e-mail real entra por
 * UPDATE no banco. Aqui ficam só o UUID e a regra do que conta como e-mail. TS puro.
 */

/** Linha "Suporte GeoGuard" em `contacts` (ver `SUPORTE_TECNICO_SEED`). */
export const CONTATO_SUPORTE_APP_ID = 'c0200a00-0000-4000-a000-000000000016';

/** E-mail utilizável, ou `null` — vazio e placeholder (`[A preencher]`) não servem. */
export function emailDeContato(bruto: string | null | undefined): string | null {
  const email = (bruto ?? '').trim();
  return /^[^\s@[\]]+@[^\s@]+\.[^\s@]+$/.test(email) ? email : null;
}
